export type VehiclesRequestBody = {
  vehicleIds: Array<string>;
};
